import { createSlice } from '@reduxjs/toolkit'

const stateSlice = createSlice({
    name: 'sizeTrash/state',
    initialState: {
        deleteConfirmation: false,
        recoverConfirmation: false,
        selectedSize: [],
        sortedColumn: () => {},
    },
    reducers: {
        toggleDeleteConfirmation: (state, action) => {
            state.deleteConfirmation = action.payload
        },
        toggleRecoverConfirmation: (state, action) => {
            state.recoverConfirmation = action.payload
        },
        setSortedColumn: (state, action) => {
            state.sortedColumn = action.payload
        },
        setSelectedSize: (state, action) => {
            state.selectedSize = action.payload
        },
    },
})

export const { 
    toggleDeleteConfirmation,
    toggleRecoverConfirmation,
    setSortedColumn,
    setSelectedSize
} = stateSlice.actions

export default stateSlice.reducer
